import { MinimizedChat } from "../../../types/chat";
import '../../../Styles/Space/Space Page/SpaceChatItem.css';
import { Delete01Icon, FolderRemoveIcon, LinkSquare02Icon, Message01Icon } from "hugeicons-react";
import { getRelativeTime } from "../../../helpers/chatHelper";
import { useCallback, useState } from "react";
import { useAppData } from "../../../contexts/AppDataContext";
import { useWindow } from "../../../contexts/WindowContext";
import { useNavigate } from "react-router-dom";
import { HoverToolTip } from "../../../components/Layout/Items/HoverToolTip";

interface SpaceChatItemProps {
  chat: MinimizedChat;
  isPreview?: boolean;
}

export const SpaceChatItem = ({ chat, isPreview = false }: SpaceChatItemProps) => {
    const navigate = useNavigate();
    const { removeChat, removeChatFromSpace } = useAppData();
    const { openConfirmationModal } = useWindow();
    const [isHovered, setIsHovered] = useState(false);

    const handleDeleteChat = (chat: MinimizedChat) => {
        openConfirmationModal(
          "Are you sure you want to delete this chat?",
          () => {
            removeChat(chat.id);
          },
          null
        );
      };

    const handleMouseEnter = () => {
        setIsHovered(true);
    };

    const handleMouseLeave = () => {
        setIsHovered(false);
    };

    const handleChatNavigation = useCallback((chatId: string) => {
      navigate(`/${chatId}`);
    }, [navigate]);

    const handleChatNavigationinNewTab = useCallback((e: React.MouseEvent, chatId: string) => {
      e.stopPropagation();
      window.open(`/${chatId}`, '_blank');
    }, []);

    
  return (
    <div className="space-chat-item" onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave} onClick={() => isPreview ? {} : handleChatNavigation(chat.id)}>
      <div className="space-chat-item-left">
        <Message01Icon size={18} />
        <h3>{chat.title}</h3>
      </div>
      <div className="space-chat-item-right">
        {isHovered ?(
          <>
          <>
            <button
              disabled={isPreview}
              type="button"
              className="space-chat-button"
              onClick={(e) => {
                e.stopPropagation();
                handleChatNavigationinNewTab(e, chat.id);
              }}
            >
              <LinkSquare02Icon size={14} />
              <HoverToolTip text="Open in New Tab" position="top" />
            </button>
            <button
              disabled={isPreview}
              type="button"
              className="space-chat-button"
              onClick={(e) => {
                e.stopPropagation();
                removeChatFromSpace(chat.id);
              }}
            >
              <FolderRemoveIcon size={14} />
              <HoverToolTip text="Remove from Space" position="top" />
            </button>
            <button
              disabled={isPreview}
              type="button"
              className="space-chat-button"
              onClick={(e) => {
                e.stopPropagation();
                handleDeleteChat(chat);
              }}
            >
              <Delete01Icon size={14} />
              <HoverToolTip text="Delete Chat" position="top" />
            </button>
          </>
          </>
        ) : (
          <span>{getRelativeTime(chat.lastModified)}</span>
        )}
      </div>
    </div>
  );
};